var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowRightDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_16"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_16",
    "data-name": "Artboard \\u2013 16",
    clipPath: "url(#clip-Artboard_16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-arrow-alt-circle-down",
    "data-name": "Icon awesome-arrow-alt-circle-down",
    d: "M25.45,13.006A12.444,12.444,0,1,1,13.006.563,12.442,12.442,0,0,1,25.45,13.006ZM10.8,7.186v5.82H7.241a.6.6,0,0,0-.426,1.029L12.58,19.77a.6.6,0,0,0,.848,0l5.765-5.735a.6.6,0,0,0-.426-1.029H15.214V7.186a.6.6,0,0,0-.6-.6H11.4A.6.6,0,0,0,10.8,7.186Z",
    transform: "translate(-5.838 12.556) rotate(-45)",
    fill: "#ef8c0b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRightDown);
export default __webpack_public_path__ + "static/media/iconArrowRightDown.0180f1660b56da7e5d01d672f38b0793.svg";
export { ForwardRef as ReactComponent };